<template>
  <!-- :style="{
      'background-image':
        'url(/images/theme/' + currentTheme + '/back-new.jpg)',
    }" -->
  <div id="app">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.routerAlive" />
    </keep-alive> -->
    <!-- <router-view v-if="!$route.meta.routerAlive" /> -->
    <router-view v-if="isRouterAlive" />
    <div
      v-if="currPage !== 'Login'"
      style="position: absolute; top: 100px; left: 20px; z-index: 100"
    ></div>
    <!-- <div
      v-if="idLoadMap"
      id="global-map-container"
      :class="['map-view', mapVisible ? 'show' : '']"
    >
      <appMap
        ref="appMap"
        @mapReady="mapReady"
        v-if="isRouterAlive && mapInit"
      ></appMap>
    </div> -->
  </div>
</template>
<script>
import theme from "@src/common/lib/theme";
import themeConfig from "@src/common/config/theme";
// import lang from "@src/common/lib/lang";
// import languageConfig from "@src/common/config/language";
// import appMap from '@src/components/common/app-map/app-map'
// import appMap from "@src/components/common/gis/index";
import sysInit from "@src/init";
export default {
  name: "App",
  components: {
    // appMap,
  },
  data: () => {
    return {
      currPage: "",
      systemList: [],
      idLoadMap: true, //window.systemConfig.LOAD_MAP,
      mapVisible: false,
      isRouterAlive: true,
      mapInit: true,
      currentTheme: "newDark",
    };
  },
  provide() {
    return {};
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    // currentTheme() {
    //   return "newDark" || this.$store.getters.currentTheme;
    // },
    currentLanguage() {
      return this.$store.getters.currentLanguage;
    },
  
  },
  watch: {
    // 监听主题发生变化后，进行主题切换
    // currentTheme(newVal, oldVal) {
    //   theme.updateTheme(newVal, oldVal);
    //   this.$log.info(
    //     "页面主题切换成功，切换前的主题：",
    //     oldVal,
    //     "；切换后的主题：",
    //     newVal
    //   );
    // },
    // 监听语种发生变化后，进行语种切换，reload方法通过隐藏和展示整个页面，从而触发页面刷新
    // currentLanguage(newVal, oldVal) {
    //   lang.updateLanguage(newVal);
    //   this.reload();
    //   const newLang =
    //     languageConfig.LANGUAGE_MAP[newVal] &&
    //     languageConfig.LANGUAGE_MAP[newVal].name;
    //   const oldLang =
    //     languageConfig.LANGUAGE_MAP[oldVal] &&
    //     languageConfig.LANGUAGE_MAP[oldVal].name;
    //   this.$log.info(
    //     "页面语种切换成功，切换前的语种：",
    //     oldLang,
    //     "；切换后的语种：",
    //     newLang
    //   );
    // },
  },
  created() {
    this.$store.commit("SET_ISDownload", false);
    // 系统初始化时，如果当前缓存中包含主题，则设置缓存中的主题；如果缓存中不包含主题，则设置为默认主题
    this.$store.dispatch(
      "setCurrentTheme",
      this.currentTheme || themeConfig.DEFAULT_THEME
    );
    theme.updateTheme(this.currentTheme, themeConfig.DEFAULT_THEME);
    // 系统初始化时，如果当前缓存中包含语种，则设置缓存中的语种；如果缓存中不包含语种，则设置为默认语种
    // this.$store.dispatch(
    //   "setCurrentLanguage",
    //   this.currentLanguage || languageConfig.DEFAULT_LANGUAGE
    // );
    // lang.updateLanguage(this.currentLanguage, languageConfig.DEFAULT_LANGUAGE);
    // this.reload();
    // 如果用户未登录，则需要在判断内外网之后再加载地图
    // 如果用户已登录，则直接加载地图
    // 避免用户登录成功后，在地图页面刷新页面时，出现地图加载太慢的问题
    // this.testNetwork(!!(this.userInfo && this.userInfo.access_token));
  },
  mounted() {
    // 应用加载时，即获取系统数据字典
    sysInit.initDic.apply(this);
    this.currPage = this.$route.name;
    // this.$app.setAppInstance({
    //   reload: () => {
    //     this.reload();
    //   },
    //   showMap2D: () => {
    //     console.log("地图显示");
    //     this.mapVisible = true;
    //     // this.$refs.appMap.setMapCenter()
    //   },
    //   hideMap2D: () => {
    //     console.log("地图隐藏");
    //     if (this.mapVisible == true) {
    //       this.$refs.appMap.setMapCenter();
    //       this.$refs.appMap.clear();
    //     }
    //     this.mapVisible = false;
    //   },
    // });
    // 监听页面全屏事件，当页面的全屏状态发生变化时，设置全局全屏状态
    // 该监听可监听用户点击按钮改变全屏状态和通过ESC按钮退出全屏
    this.$utils.listenFullScreen("add", () => {
      this.$store.commit("fullScreen", this.$utils.isFullScreen());
    });
    // if (!this.idLoadMap) {
    //   this.$map.setMapInstance2D({
    //     clearPoint: () => {},
    //     addMarket: () => {},
    //     addFlashMarket: () => {},
    //     removeTrajectory: () => {},
    //     clearFlickerAnimation: () => {},
    //     clearShape: () => {},
    //     drawTrajectory: () => {},
    //     destroyLocation: () => {},
    //     resetMapStyle: () => {},
    //     resetRectangle: () => {},
    //     rectangle: () => {},
    //     clear: () => {},
    //   });
    // }
  },
  methods: {
    /**
     * [reload 页面重新加载的方法，将整个页面先销毁，再重新展示，触发所有页面及组件的初始化方法]
     * @return {[Null]} [无]
     */
    // reload() {
    //   this.isRouterAlive = false;
    //   this.$nextTick(() => {
    //     this.isRouterAlive = true;
    //   });
    // },
    /*
     *@name:
     *@param:{type}
     *@description:
     *@return:
     *@author: 作者
     *@date: 2020-04-03 17:53:49
     */
    // mapReady() {
    //   // this.$refs.appMap.initMap();
    //   this.$map.setMapInstance2D(this.$refs.appMap);
    //   // window.eventBus.$emit('map2DReady');
    //   console.log("3地图对象注册到全局", this.$map);
    //   // this.$map.mapReady();
    // },
  },
};
</script>
<style>
#app {
  overflow: auto;
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  /* background-color: #0d121c; */
  background-size: cover;
  /* 背景图片加载慢的时候展示背景色 */
  /* background-color: #0039a9; */
  /* background-color: #001451; */
}
#nprogress .bar {
  background: #407aee !important;
  height: 2px !important;
}
#myCanvas {
  position: relative !important;
}
</style>
